import React, { Component } from 'react';
import {connect} from "react-redux";
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn, Form, Icon, Input, Label} from "semantic-ui-react";
import Lbl from "../../../components/Label/Lbl";
import LabelInput from "../../../components/Input/Input/TxtLbl";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import {Icon as AntdIcon, Spin, Tooltip} from "antd";
import {MDBDataTable} from "mdbreact";
import * as EmailValidator from "email-validator";
import * as common from "../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import axios_tag from "../../../axios/axios_tag";
import * as actionCreator from "../../../store/Action";
import Update from './Update/Update';
import $ from "jquery";
import IntlTelInput from "react-intl-tel-input";
import apiConfig from "../../../axios/axios_api_services";


class App extends Component {

// ----------------------------------------------- [State] -------------------------------------------------------------

  state = {
    email: "",
    name: "",
    username: "",
    valid_mobile: false,
    mobile: "",
    format_mobile:"",
    // mobile_: "",
    password: "",
    validatePassword: false,
    validEmail: false,
    selected_list: [],
    isLoadOrganizer: false,
    organizer_list: [],
    isUpdate: false,
    organizer_data:null
  };

// ----------------------------- [function - handle changing of inputs | note: used] -----------------------------------

  handleChange = (name, length) => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else if (name === "email") {
      let validateEmail = EmailValidator.validate(value.trim());
      if (validateEmail) {
        this.setState({
          validEmail: true,
          [name]: value
        });
      } else {
        this.setState({
          validEmail: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      selected_list: value
    })
  };

  //change phone number handler
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };

// ------------------------------- [function - use for view password | note: used] -------------------------------------

  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

// ---------------------------- [function - use for clear input fields | note: used] -----------------------------------

  clearFeilds = () => {
    this.setState({
      email: "",
      name: "",
      username: "",
      valid_mobile: false,
      mobile: "",
      format_mobile:"",
      // mobile_: "",
      password: "",
      validatePassword: false,
      validEmail: false
    });
  };

// ------------------------- [function - use for add new organizer | note: used ] --------------------------------

  addOrganizer = () => {
    this.state.name.trim() === '' ? common.notifyMessage("Please enter full name") :
      this.state.username.trim() === "" ? common.notifyMessage("Please enter username") :
        this.state.email.trim() === "" ? common.notifyMessage("Please enter email") :
          !this.state.validEmail ? common.notifyMessage("Please enter valid email") :
            this.state.mobile.trim() === "" ? common.notifyMessage("Please enter mobile number") :
              !this.state.valid_mobile ? common.notifyMessage("Please enter valid mobile number") :
                !this.state.validatePassword ? common.notifyMessage("Password must contain at least 9 characters, including " +
                  "UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS") :
                  // this.state.selected_list.length === 0 ? common.notifyMessage("Please enter branches") :
                    swal({
                      title: "Click YES to add a new Organizer",
                      icon: are_you_sure_icon,
                      closeOnClickOutside: false,
                      buttons: {
                        cancel: 'Cancel',
                        dangerMode: {
                          text: "Yes",
                          value: "action",
                          className: "okay-btn"
                        }
                      },
                    }).then((value) => {
                      switch (value) {
                        case "action":
                          this.sendToBackend();
                          break;
                        default:
                          break;
                      }
                    });
  };

// ------------------------- [function - send to backend to data od new adding oranizer] -------------------------------

  sendToBackend = () => {
    const obj = {
      branchId: [],
      fullName: this.state.name,
      userName: this.state.username,
      email: this.state.email,
      mobile: this.state.format_mobile,
      password: this.state.password,
      userRoles: "CORP_EVENT_ORGANIZER",
      status: 1,
    };
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_tag.put(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporates[0].corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Event Orgernizer successfully created - (" + this.state.username + ")", 0);
          this.clearFeilds();
          this.getAllOrganizers();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };


// ------------------------- [function - use for get all organizers | note: not use yet] -------------------------------

  getAllOrganizers = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "user_type":"CORP_EVENT_ORGANIZER"
    };
    // this.loadSpin("isLoadReception", true);

    axios_tag.get(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporates[0].corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            organizer_list:response.data.adminUserList
          })
        } else {
          this.setState({
            organizer_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllOrganizers();
        }
      })
      // .finally(fin => {
      //   this.loadSpin("isLoadOrganizer", false);
      // });
  };

// ------------------------------- [function - update organizer | note: not use yet] ----------------------------------

  updateOrganizer = (value) => {

    this.setState({
      isUpdate: true,
      organizer_data:value
    })
  };
// ------------------------------- [function - delete organizer | note: not use yet] ----------------------------------
  deleteOrganizer = (id,name) => {alert("delete orgernizer")};
  deleteOrganizerX = (id,name) => {
    swal({
      text:"Are you sure you want to delete this orgernizer? \n If so please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteOrganizer_(id)
        }else{
          common.warningAlert("Can't delete Receptionist", 1)
        }
      });
  };
  deleteOrganizer_ = (id) => {
    this.props.spinnerHandler(true);
    alert("User deleted Successfully");
  };


// --------------------------------------------- [ componentDidMount ] -------------------------------------------------

  componentDidMount() {
    this.getAllOrganizers();
    $('input').attr('autocomplete', 'off');
  }

// --------------------------------------------- [ render & return ] ---------------------------------------------------

  render() {
    const rows = [];
    if (this.state.organizer_list.length !== 0) {
      this.state.organizer_list.map((value, index) => {
        rows.push(
          {
            name: value.fullName,
            userName: value.userName,
            mobile: value.mobile,
            email: value.email,
            added_by: value.addedBy,
            added_date: common.convertDate(value.addedDate),
            modify_by: value.modifyBy,
            modify_date: common.convertDate(value.modifyDate),
            // status: value.status !== 1 ? <div><Label circular color={'red'} empty key={index} /><p>{"Inactive"}</p></div>
            //   : <div><Label circular color={'green'} empty key={index} /><p>{"Active"}</p></div>,
            status: value.status !== 1 ? "Inactive" : "Active",
            action:
              <div>
                <SementicBtn icon='edit' circular onClick={() => this.updateOrganizer(value)}/>
                {/*<SementicBtn className="cus-btn" circular icon='trash alternate'*/}
                             {/*onClick={() => this.deleteOrganizer(value.userId,value.userName)}/>*/}
              </div>
          }
        )
      });
    }
    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (

      <div>
        {
        this.state.isUpdate ?
        <Update data={this.state.organizer_data} refreshData={this.clearFeilds} closeModal={()=>this.setState({isUpdate:false})} addUpdate={this.getAllOrganizers}/>:null
        }
        <Card>
          <CardHeader>Manage Event Organizer</CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Full Name</Lbl>
                        <LabelInput
                          placeholder={"Full Name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')} // e - me
                        />
                      </Col>

                        <Col className={"none-padding"} lg={12}>
                          <Lbl required>User Name</Lbl>
                          <LabelInput
                            placeholder={"User Name"}
                            value={this.state.username}
                            onChange={this.handleChange('username')}
                          />
                        </Col>

                        <Col lg="12" md={"12"} sm={"12"} xs={"12"} style={{marginTop:'14px', marginBottom: '14px', paddingLeft: '0px', paddingRight: '0px'}}>
                          <Lbl required style={{marginTop:'0px!important'}}>Event Organizer Mobile</Lbl>
                          <IntlTelInput
                            type={"text"}
                            fieldName={"Mobile Number"}
                            style ={{width:'100%', height:'37px'}}
                            value={this.state.mobile}
                            containerClassName="intl-tel-input dashboard-intl"
                            inputClassName="form-control"
                            onPhoneNumberChange={this.onPhoneNumberChange}
                            required={true}
                            preferredCountries={['lk']}
                            defaultCountry={"lk"}
                            nationalMode={false}
                            // customPlaceholder={this.customPlaceholder}
                          />
                        </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Email</Lbl>
                        <LabelInput
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Col>

                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Password</Lbl>
                        <Input id={"password-field"} type={"password"}
                               onChange={this.handleChange('password')}
                               value={this.state.password}
                               style={{width: '100%'}}
                               icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                           onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                               placeholder='Password'/>
                      </Col>

                    </Form>

                    <Row>
                      <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                        <center>
                          <Button
                            className="addBtn"
                            color="primary"
                            onClick={e => this.addOrganizer(e, 'addOrganizer')}
                          >Add Organizer</Button>

                          <Tooltip placement="topLeft" title="Clear input fields">
                            <SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>
                          </Tooltip>

                        </center>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card className="card margin0" >
          <CardHeader>All Event Organizers</CardHeader>
          <CardBody>
            <Spin spinning={this.state.isLoadOrganizer} delay={10}
                  indicator={<AntdIcon type="loading" style={{fontSize: 24}} spin={"true"}/>}>
              <MDBDataTable
                searching={true}
                displayEntries={true}
                exportToCSV={true}
                entries={8}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                striped
                data={table_data}
                />
            </Spin>
          </CardBody>
        </Card>
      </div>

    );


  }
}

// ----------------------------------- [ mapStateToProps & mapDispatchToProps ] ----------------------------------------

const mapStateToProps = (state) => ({
  table_data: state.eventOrganizerReducer.Event_Organizer_Table_data,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
